<template>
  <!-- 物流信息  logisticsInfo -->
  <div>
    <a-modal
      title="物流信息"
      :visible='visibel'
      @cancel="visibel = false"
      :footer="null"
      :keyboard="true"
      centered
      :width="1000"
    >
      <p>运单号：{{logisticsNo}}</p>
      <div>
        <div v-if="logisticsInfo.length==0&&statusDesc!=''">
          <h1 style="font-size:18px;margin-top: 50px;text-align: center;">{{statusDesc}}</h1>
        </div>
        <div style="width:100%;height:100px;padding-top:50px;" v-show="showLoading">
          <a-spin tip="Loading...">
            <div class="spin-content">
            </div>
          </a-spin>
        </div>

        <div id="internal" style="" role="result" class="">
          <div class="result-body">
            <div class="result">
              <ul class="content">
                <li class="step" v-for="(item,index) in logisticsInfo" :class="index == 0&&logisticsInfo.length!=1? 'start':index == logisticsInfo.length -1?'end':''">
                  <div class="datetime">{{item.acceptTime}}</div>
                  <div class="step-icon"></div>
                  <div class="text">
                    {{item.acceptStation}}
                  </div>
                </li>
              </ul>
            </div>

          </div>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
export default {
  name: 'logisticsInfo',
  data () {
    return {
      visibel: false,
      showLoading: true,
      logisticsInfo: [],
      logisticsNo: undefined,
      statusDesc: undefined
    };
  },

  created () {
  },
  methods: {
    show (logisticsCode, logisticsNo) {
      this.logisticsNo = logisticsNo;
      this.visibel = true;
      this.showLoading = true;
      this.$get({
        url: '/express/getLogisticInfo',
        params: {
          deliveryCompanyCode: logisticsCode,
          deliverySn: logisticsNo
        }

      }).then((res) => {
        this.logisticsInfo = res.data.traces;
        this.showLoading = false;
        this.statusDesc = res.data.statusDesc || '';
      });
    }
  }
};
</script>
<style scoped>

ul,ol,dd,dt,p,div {
  padding: 0;
  margin: 0
}

li {
  list-style: none
}

.result-body {
  padding: 20px 40px;
}

.result-body .result {
  width: 880px;
}

.result-body .title .text {
  display: inline-block;
  margin-left: 164px;
}

.result-body .content {
  margin-top: 40px;
}

.result-body .step {
  position: relative;
  padding-bottom: 35px;
  font-size: 14px;
  color: #666;
}

.result-body .datetime {
  display: inline-block;
  vertical-align: top;
  width: 84px;
  font-size: 12px;
}

.result-body .step-icon {
  display: inline-block;
  vertical-align: top;
  margin: 0 83px;
  width: 22px;
  height: 22px;
  background: url(https://cdn.kuaidi100.com/images/www/sp-index.png) -285px -131px no-repeat #FFF;
}

.result-body .step.start {
  color: #0082FA;
}

.result-body .step.ing {
  color: #FF9631;
}

.result-body .step.start .step-icon {
  background-position: -239px -41px;
  /* margin-top: -4px; */
}

.result-body .step .text {
  position: relative;
  display: inline-block;
  vertical-align: top;
  width: 590px;
}

.result-body .step:after {
  position: absolute;
  top: 22px;
  bottom: 2px;
  left: 177px;
  width: 1px;
  background: #e8e8e8;
  content: '';
}

.result-body .step.end:after {
  display: none;
}

.result-footer {
  padding: 24px;
  margin: 0 40px;
  text-align: center;
  font-size: 14px;
  color: #666;
}

</style>
